import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

import { useRawGetOrganisationHierarchy } from './UseRawGetOrganisationHierarchy';

export function useOrganisationHierarchy() {
  const getOrganisationHierarchy = useRawGetOrganisationHierarchy();
  return useQueryWithErrorHandling({
    queryKey: ['organisation-hierarchy'],
    queryFn: getOrganisationHierarchy,
  });
}
